import React, { useEffect } from "react";

import PluginLoader from "@views/plugins/PluginLoader";

const PLUGIN_KEY = "sy_plugin_profiler";
export default function PluginProfiler() {
    useEffect(() => {
        PluginLoader(PLUGIN_KEY);
    }, [])

    return (
        <div id={PLUGIN_KEY}> </div>
    );
}
